export enum LogListingType {
  ResidentDetail = 'residentdetail',
  StakeholderDetail = 'stakeholderdetail',
  StakeholderAll = 'stakeholderall',
  ComplaintDetail = 'complaintdetail',
  IssueDetail = 'issuedetail',
  EmployeeDetail = 'employeedetail',
}
